import React from 'react';
import * as S from './styles';

interface NavbarCenterProps {
	children: React.ReactNode;
}

const NavbarCenter = ({ children }: NavbarCenterProps) => {
	return <S.Base>{children}</S.Base>;
};

export default NavbarCenter;
